import classNames from 'classnames';
import { RevxMoney } from 'components/RevxMoney';
import { useEffect, useMemo, useState } from 'react';
import './index.less';

export type RevxCircleLabelProps = {
  text: string | number;
  name: string;
  defaultChecked?: boolean;
  checked?: boolean;
  size?: 'small' | 'large';
  enableHoverActive?: boolean;
  money?: number;
  onChange?: (checked: boolean) => void;
  clickable?: boolean;
  disabled?: boolean;
};

export const RevxCircleLabel = (props: RevxCircleLabelProps) => {
  const [checked, setChecked] = useState<boolean>(() => {
    if (props.checked !== undefined) {
      return props.checked;
    } else if (props.defaultChecked !== undefined) {
      return props.defaultChecked;
    } else {
      return false;
    }
  });

  useEffect(() => {
    if (props.checked !== undefined) {
      setChecked(props.checked);
    }
  }, [props.checked]);

  const styleRender = useMemo(() => {
    return {
      cursor: Boolean(props.disabled) ? 'not-allowed' : 'default',
    };
  }, [props.disabled]);

  return (
    <div
      className={classNames('revx-circle-label', {
        checked: checked,
        hoverActive: props.enableHoverActive,
        small: props.size === 'small',
        large: props.size === 'large',
      })}
    >
      <div
        className="revx-circle-label-inner"
        style={styleRender}
        onClick={() => {
          if (Boolean(props.disabled)) {
            return false;
          }
          const newChecked = !checked;
          if (props.checked === undefined) {
            setChecked(newChecked);
          }

          if (props.onChange) {
            props.onChange(newChecked);
          }
        }}
      >
        <div
          className={classNames('revx-circle-label-inner-border', {
            clickable: props.clickable !== false,
          })}
          style={styleRender}
        >
          <div
            className={classNames('revx-circle-label-inner-border-inner', {
              'long-text': String(props.text).length > 2,
            })}
          >
            {props.text}
          </div>
        </div>
        {props.name && (
          <>
            <div className="revx-circle-label-inner-name">{props.name}</div>
            {props.money !== undefined && <RevxMoney value={props.money} />}
          </>
        )}
      </div>
    </div>
  );
};
